import common from "@page/common/js/common";
import corpPage from "@global/components/global/staticInfoPage";
var Path = require("@global/vendors/path");

corpPage();

// 桌機版沒目錄頁導頁
if (!nowEnv.NowMyEquipment) {
	const href = $(".howToBuy-tab >ul >li >a").attr("href");
	location.href = href;
}
